import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import {MatExpansionModule} from '@angular/material/expansion';
import {
  FormArray,
  FormGroup,
  FormGroupDirective,
  ReactiveFormsModule,
} from '@angular/forms';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { Course, Subsection } from 'src/app/admin/data-access/course.model';
import { MatIconModule } from '@angular/material/icon';
import {checkForHTMLTags} from "../../../../shared/utils/checkForHTMLTags";

@Component({
    selector: 'app-exam-summary',
    templateUrl: './summary.component.html',
    styleUrls: ['./summary.component.scss'],
    imports: [CommonModule, MatIconModule, MatExpansionModule, ReactiveFormsModule, CdkAccordionModule]
})
export class SummaryComponent implements OnInit {
  @Input() subsections: Subsection[] = [];
  @Input() courses: Course[] = [];

  summaryExamForm!: FormGroup;
  panelOpenState = false;
  isOpen: boolean = false;
  rootFormGroup = inject(FormGroupDirective);
  constructView: any;
  assignView: any;

  ngOnInit(): void {
    this.summaryExamForm = this.rootFormGroup.control as FormGroup;
    this.constructView = this.summaryExamForm.get('construct')?.getRawValue();
    this.assignView = this.summaryExamForm.get('assign')?.getRawValue();
  }

  togglePanel() {
    this.isOpen = !this.isOpen;
  }

  get parts(): FormArray {
    return this.summaryExamForm.get('construct')?.get('general')?.get('parts') as FormArray;
  }

  retrieveSubsectionName(subsection_id: number) {
    const subsection = this.subsections?.find(
      (subsection) => subsection.subsection_id == subsection_id
    );
    return subsection?.name ?? 'Subsection not selected';
  }

  retrieveCourseName(course_id: number) {
    const course = this.courses?.find(
      (course) => course.course_id == course_id
    );
    return course?.name ?? 'Course not selected';
  }

  convertMinutes(minutes: number) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    if(hours == 0)
      return `${remainingMinutes} minute(s)`;
    else if(remainingMinutes == 0)
      return `${hours} hour(s)`;
    else
      return `${hours} hour(s) and ${remainingMinutes} minute(s)`;
  }

  protected readonly JSON = JSON;
  protected readonly checkForHTMLTags = checkForHTMLTags;
  protected readonly FormArray = FormArray;
}
